import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';

export const StyledInfoIcon = styled(InfoIcon)(({ theme }) => {
  return {
    display: 'flex',
    color: theme.palette.neutral[600],
    marginLeft: '8px',
  };
});
